import React from "react";

/* COMPONENTS */
import PaymentCard from "./PaymentCard"

/* INTERFACES */
import { paymentMethods } from "../../Interfaces"

/* UTILS | HELPERS */
import { getCloudImageUrl } from "../../../../utils"

type PaymentTypeWrapperProps = {
  type: string
  description: string
  addtional_class_for_card: string
  additionalWrapperClass?: string

  disabled?: boolean
  payment_methods: Array<paymentMethods>

  choosePaymentHandler: (item: paymentMethods) => void
}

const PaymentTypeWrapper: React.FC<PaymentTypeWrapperProps> = ({
  children,
  disabled,
  type,
  description,
  addtional_class_for_card,
  additionalWrapperClass,
  payment_methods,
  choosePaymentHandler
}): JSX.Element => {
  return (
    <div className={`payment-type-wrapper ${additionalWrapperClass ? additionalWrapperClass : ""}`}>
      <div className="title-text-wrapper">
        <p>{type}</p>
        <p>{description}</p>
      </div>
      {
        payment_methods.map(payment => {
          const isDisabled = (() => {
            if(!payment.active) return true
            if(disabled || payment.disabled) return true
            return false
          })();
          
          return (
            <PaymentCard
              additional_class={addtional_class_for_card}
              image_url={getCloudImageUrl(payment.logo)}
              disabled={isDisabled}
              choosePaymentHandler={() => choosePaymentHandler(payment)}
            >
              {
                children ? children : <p>{payment.label}</p>
              }
            </PaymentCard>
          )
        })
      }
    </div>
  )
}

export default PaymentTypeWrapper